import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Rightpart.css";
import profile from "../assets/images/profile.png";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "../../api/axios";

export default function ProfileRight() {
  const [user, setUser] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [profileImg, setProfileImg] = useState(profile);
  
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);
  
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");

  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      const parsedUser = JSON.parse(userData);
      setUser(parsedUser);
      setProfileImg(parsedUser.avatar_original || parsedUser.avatar || profile);
    }

    axios.get("/customer/info")
      .then(response => {
        if (response.data && response.data.data && response.data.data.length > 0) {
          const customer = response.data.data[0];
          const nameParts = (customer.name || "").split(" ");
          setFirstName(nameParts[0] || "");
          setLastName(nameParts.slice(1).join(" ") || "");
          setEmail(customer.email || "");
          setPhone(customer.phone || "");
          setAddress(customer.address || "");
          if (customer.avatar) {
            setProfileImg(customer.avatar);
          }

          // Sync localStorage and notify components
          const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
          storedUser.name = customer.name;
          storedUser.email = customer.email;
          storedUser.phone = customer.phone;
          if (customer.avatar) {
            storedUser.avatar_original = customer.avatar;
          }
          localStorage.setItem("user", JSON.stringify(storedUser));
          setUser(storedUser);
          window.dispatchEvent(new Event("user-profile-updated"));
        }
      })
      .catch(error => {
        console.error("Error fetching profile info:", error);
      });
  }, []);

  const handleEditClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Content = reader.result.split(',')[1];
        setProfileImg(reader.result);

        axios.post("/profile/update-image", {
          image: base64Content,
          filename: file.name
        })
        .then(response => {
          if (response.data.result) {
            const updatedPath = response.data.path;
            // Update user in state and localStorage
            const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
            storedUser.avatar_original = updatedPath;
            localStorage.setItem("user", JSON.stringify(storedUser));
            setUser(storedUser);
            window.dispatchEvent(new Event("user-profile-updated"));
          } else {
            console.error("Failed to update image:", response.data.message);
          }
        })
        .catch(err => {
          console.error("Error uploading image:", err);
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpdateProfile = (e) => {
    e.preventDefault();
    setMessage("");
    setErrorMessage("");
    setLoading(true);

    const fullName = `${firstName} ${lastName}`.trim();

    axios.post("/profile/update", {
      name: fullName,
      phone: phone,
      address: address
    })
    .then(response => {
      if (response.data.result) {
        setMessage(response.data.message || "Profile updated successfully.");
        // Update user in localStorage
        const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
        storedUser.name = fullName;
        storedUser.phone = phone;
        localStorage.setItem("user", JSON.stringify(storedUser));
        setUser(storedUser);
        window.dispatchEvent(new Event("user-profile-updated"));
      } else {
        setErrorMessage(response.data.message || "Failed to update profile.");
      }
    })
    .catch(error => {
      setErrorMessage(error.response?.data?.message || error.message || "An error occurred.");
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    setPasswordMessage("");
    setPasswordErrorMessage("");

    if (!password) {
      setPasswordErrorMessage("Please enter a new password.");
      return;
    }
    if (password !== confirmPassword) {
      setPasswordErrorMessage("Passwords do not match.");
      return;
    }

    setPasswordLoading(true);

    axios.post("/profile/update", {
      password: password
    })
    .then(response => {
      if (response.data.result) {
        setPasswordMessage("Password changed successfully.");
        setPassword("");
        setConfirmPassword("");
      } else {
        setPasswordErrorMessage(response.data.message || "Failed to change password.");
      }
    })
    .catch(error => {
      setPasswordErrorMessage(error.response?.data?.message || error.message || "An error occurred.");
    })
    .finally(() => {
      setPasswordLoading(false);
    });
  };

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    localStorage.removeItem("wishlist_slugs");
    window.dispatchEvent(new Event("user-profile-updated"));
    window.dispatchEvent(new Event("wishlist-slugs-updated"));
    axios.get("/auth/logout").catch(() => {});
    navigate("/login");
  };

  return (
    <div className="outer-div-right">
      <div className="dashbord-right-section">
        <div className="dashbord-header">
          <p className="title-dash">Profile</p>

          <div className="dropdown-section d-flex align-items-center">
            <div className="dropdown">
              <button
                className="btn dropdown-toggle d-flex align-items-center gap-3"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="profile-name">
                  <img src={user?.avatar_original || user?.avatar || profile} alt="Profile" style={{ width: '40px', height: '40px', borderRadius: '50%' }} />
                  <div className="name-mail">
                    <h4>{user?.name || "User"}</h4>
                    <p>{user?.email || user?.phone || "Email/Phone"}</p>
                  </div>
                </div>
                <ExpandMoreIcon />
              </button>

              <ul className="dropdown-menu ">
                <li><Link to="/profile" className="dropdown-item">Profile</Link></li>
                <li><Link to="/support" className="dropdown-item">Support</Link></li>
                <li><button onClick={handleLogout} className="dropdown-item w-100 text-start border-0 bg-transparent">Logout</button></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="content-dashborad-outer">
          <div className="row">
            <div className="col-lg-4">
              <div className="profile-pg">
                <div className="profile-container">
                  <div className="profile-photo-pg">
                    <img src={profileImg} alt="Profile" />
                    <div
                      className="edit-icon-overlay"
                      onClick={handleEditClick}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="white"
                      >
                        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                      </svg>
                    </div>
                  </div>
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept="image/*"
                    style={{ display: "none" }}
                  />
                </div>
                <h4>{user?.name || "User"}</h4>
                <div className="detail-cst">
                  <div className="icon-info">
                    <EmailOutlinedIcon />
                    <p>{email || "No Email Registered"}</p>
                  </div>
                  <div className="icon-info">
                    <LocalPhoneOutlinedIcon />
                    <p>{phone || "No Phone Registered"}</p>
                  </div>
                  <div className="icon-info">
                    <FmdGoodOutlinedIcon />
                    <p>{address || "No Address Added"}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="profile-detail">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="billing-add-box">
                      <div className="box-top">
                        <div className="sr-number">
                          <h4>Profile details</h4>
                        </div>
                      </div>
                      <div className="billing-text profile-form">
                        <form onSubmit={handleUpdateProfile}>
                          {message && <div className="alert alert-success">{message}</div>}
                          {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                          <div className="row">
                            <div className="col-md-6">
                              <input
                                type="text"
                                placeholder="First Name"
                                className="form-control"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                placeholder="Last Name"
                                className="form-control"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                              />
                            </div>
                            <div className="col-md-12">
                              <input
                                type="email"
                                placeholder="Email Address"
                                className="form-control"
                                value={email}
                                disabled
                              />
                            </div>
                            <div className="col-md-12">
                              <input
                                type="text"
                                placeholder="Phone Number"
                                className="form-control"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                              />
                            </div>
                            <div className="col-md-12">
                              <textarea
                                placeholder="Shipping Address"
                                className="form-control"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                              ></textarea>
                            </div>
                            <div className="col-md-12">
                              <button type="submit" className="save-btn" disabled={loading}>
                                {loading ? "Saving..." : "Save"}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="billing-add-box password-sect">
                      <div className="box-top">
                        <div className="sr-number">
                          <h4>Change Password</h4>
                        </div>
                      </div>
                      <div className="billing-text password-change">
                        <form onSubmit={handleChangePassword}>
                          {passwordMessage && <div className="alert alert-success">{passwordMessage}</div>}
                          {passwordErrorMessage && <div className="alert alert-danger">{passwordErrorMessage}</div>}
                          <div className="input-box">
                            <input
                              type="password"
                              placeholder="New Password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              required
                            />
                          </div>

                          <div className="input-box">
                            <input
                              type="password"
                              placeholder="Confirm Password"
                              value={confirmPassword}
                              onChange={(e) => setConfirmPassword(e.target.value)}
                              required
                            />
                          </div>

                          <button type="submit" className="change-btn" disabled={passwordLoading}>
                            {passwordLoading ? "Changing..." : "Change Password"}
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
